import React, { useMemo, useState } from "react";
import PDFIcon from "./images/pdf-icon.png";
import heroSectionPolicy from "./images/hero-section-policy-img.webp";
import CustomerGrievancePolicy from "./pdf/Customer Grievance Policy.pdf";
import InterestRatePolicy from "./pdf/Interest Rate Policy.pdf";
import FPC_English from "./pdf/FPC_English.pdf";
import FPC_Hindi from "./pdf/FPC_Hindi.pdf";
import FPC_Punjabi from "./pdf/FPC_Punjabi.pdf";
import FPC_Marathi from "./pdf/FPC_Marathi.pdf";
import POSH_Policy from "./pdf/Posh Policy.pdf";
import VigilMechanism from "./pdf/VIGIL MECHANISM.pdf";
import Corporate_Governance_Policy from "./pdf/SVCL_Corporate Governance Policy.pdf";
import CSR_Policy from "./pdf/CSR_Policy.pdf";
import RPT_Policy from "./pdf/RPT policy_SVCL.pdf";
import NAR_Policy from "./pdf/Nomination and Remuneration Policy.pdf";
import IOS_Policy_English from "./pdf/Note on Ombudsman Scheme English.pdf";
import IOS_Policy_Hindi from "./pdf/Note on Ombudsman Scheme Hindi.pdf";
import SMA_NPA_Policy from "./pdf/SMA NPA Accounts Policy.pdf";
import CyberSecurityPolicy from "./pdf/Cyber Security Policy.pdf";
import CoLendingPolicy from "./pdf/Co-Lending Policy.pdf";
import CodeOfConductPolicy from "./pdf/Code Of Conduct Policy.pdf";
import BusinessContinuityPlanPolicy from "./pdf/Business Continuity Plan Policy.pdf";
import OutsourcingPolicy from "./pdf/Outsourcing policy_SVCL.pdf";
import PrivacyPolicy from "./pdf/Privacy Policy.pdf";
import PenalChargesPolicy from "./pdf/Penal Charges Policy.pdf";
import "./style.css";

const policies = [
  {
    name: "Customer Grievance Policy",
    files: [{ label: "View PDF", url: CustomerGrievancePolicy }],
  },
  {
    name: "Fair Practice Code",
    files: [
      { label: "English", url: FPC_English },
      { label: "Hindi", url: FPC_Hindi },
      { label: "Punjabi", url: FPC_Punjabi },
      { label: "Marathi", url: FPC_Marathi },
    ],
  },
  {
    name: "Integrated Ombudsman Scheme, 2026",
    files: [
      { label: "English", url: IOS_Policy_English },
      { label: "Hindi", url: IOS_Policy_Hindi },
    ],
  },
  {
    name: "Privacy Policy",
    files: [{ label: "View PDF", url: PrivacyPolicy }],
  },
  {
    name: "Interest Rate Policy",
    files: [{ label: "View PDF", url: InterestRatePolicy }],
  },
  {
    name: "Co-Lending Policy",
    files: [{ label: "View PDF", url: CoLendingPolicy }],
  },
  {
    name: "SMA/NPA Accounts",
    files: [{ label: "View PDF", url: SMA_NPA_Policy }],
  },
  {
    name: "Corporate Governance Guidelines",
    files: [{ label: "View PDF", url: Corporate_Governance_Policy }],
  },
  {
    name: "Nomination and Remuneration Policy",
    files: [{ label: "View PDF", url: NAR_Policy }],
  },
  {
    name: "Related Party Transactions Policy",
    files: [{ label: "View PDF", url: RPT_Policy }],
  },
  {
    name: "Code Of Conduct Policy",
    files: [{ label: "View PDF", url: CodeOfConductPolicy }],
  },
  {
    name: "Corporate Social Responsibility Policy",
    files: [{ label: "View PDF", url: CSR_Policy }],
  },
  {
    name: "Vigil Mechanism/Whistle Blower Policy",
    files: [{ label: "View PDF", url: VigilMechanism }],
  },
  {
    name: "Posh Policy",
    files: [{ label: "View PDF", url: POSH_Policy }],
  },
  {
    name: "Cyber Security Policy",
    files: [{ label: "View PDF", url: CyberSecurityPolicy }],
  },
  {
    name: "Business Continuity Plan Policy",
    files: [{ label: "View PDF", url: BusinessContinuityPlanPolicy }],
  },
  {
    name: "Outsourcing Policy",
    files: [{ label: "View PDF", url: OutsourcingPolicy }],
  },
  {
    name: "Penal Charges Policy",
    files: [{ label: "View PDF", url: PenalChargesPolicy }],
  },
];

const sortedPolicies = [...policies].sort((a, b) =>
  a.name.localeCompare(b.name),
);

function PolicyCard({ policy }) {
  return (
    <div className="policy-card">
      <div className="policy-card-top">
        <span className="policy-card-icon">
          <img src={PDFIcon} alt="" />
        </span>
      </div>
      <h4 className="policy-card-name">{policy.name}</h4>
      <div className="policy-card-actions">
        {policy.files.map((file) => (
          <a
            key={file.label}
            className="policy-card-link"
            href={file.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {file.label}
          </a>
        ))}
      </div>
    </div>
  );
}

const Policies = () => {
  const [query, setQuery] = useState("");

  const filteredPolicies = useMemo(() => {
    const term = query.trim().toLowerCase();

    if (!term) return sortedPolicies;

    return sortedPolicies.filter((policy) =>
      policy.name.toLowerCase().includes(term),
    );
  }, [query]);

  return (
    <div>
      <div className="main wrapper">
        {/* <!-- *************** HERO SECTION STARTS *************** --> */}
        <section className="hero-section">
          <img src={heroSectionPolicy} alt="" />
          <div className="hero-section-box">
            <div className="hero-section-text">
              <p>OUR POLICIES</p>
            </div>
          </div>
        </section>

        {/* <!-- *************** POLICY SECTION STARTS *************** --> */}

        <section className="policy-section">
          <div className="container">
            <div className="policy-head">
              <div className="policy-head-text">
                <h2 className="policy-heading">Our Policies</h2>
                <p className="policy-subheading">
                  Browse and download our published policies and codes.
                </p>
              </div>

              <div className="policy-search">
                <input
                  type="search"
                  value={query}
                  onChange={(event) => setQuery(event.target.value)}
                  placeholder="Search policies..."
                  aria-label="Search policies"
                />
              </div>
            </div>

            <p className="policy-count">
              Showing {filteredPolicies.length} of {policies.length} documents
            </p>

            {filteredPolicies.length === 0 ? (
              <div className="policy-empty">
                <p>No policies match your search.</p>
                <button
                  type="button"
                  className="policy-clear-btn"
                  onClick={() => setQuery("")}
                >
                  Clear search
                </button>
              </div>
            ) : (
              <div className="policy-grid">
                {filteredPolicies.map((policy) => (
                  <PolicyCard key={policy.name} policy={policy} />
                ))}
              </div>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Policies;
